<script>
import gql from 'graphql-tag'
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
export default {
  name: 'home',
  data () {
    return {
      containers_par_categorie: '',
      date_de_diffusion: '',
    }
  },
  mixins: [
    platformDetect,
    // getUsagerStatistiques,
  ],
  apollo: {
    containers_par_categorie: {
      /*eslint-disable*/
      query: gql `query containers_par_categorie($categorie: String!){
        containers_par_categorie(categorie: $categorie){
          id titre description medias{
            id image{titre url description thumbnail} mediable_id mediable_type position video{titre link minutage description url}
          }
        }
      }`,
      /*eslint-enable*/
      variables () {
        return {categorie: 'logo'}
      },
      fetchPolicy: 'cache-first',
      update: data => data.containers_par_categorie,
    },
    date_de_diffusion: {
      query: gql `query pages_par_categorie($categorie: String!, $limit: Int, $page: Int){
        pages_par_categorie(categorie: $categorie, limit: $limit, page: $page){
          id titre page_containers{
            id position container{
              id description titre medias{
                image{
                  url
                }
              }
            }
          }
        }
      }`,
      variables () {
        return { categorie: 'broadcast', limit: 40, page: 1 }
      },
      fetchPolicy: 'cache-first',
      update: data => data.pages_par_categorie,
      loadingKey: 'loading',
    },
  },
  components: {
    BaseLayout,
  },
  methods: {
    checkUrl (url) {
      // var temp = ''
    },
  },
  mounted () {
    // var myvid = document.getElementById('video1')
    // myvid.play()
  },
}
</script>
<template lang="pug">
base-layout.overflow-x-hidden(:home='true')
  div.home.flex-inline.justify-between
    //- div.backvid
    //-   video.frontvid(autoplay, loop, muted, playsinline)
    //-     source.overflow-hidden(src='~@/../static/video/intro.webm', type="video/webm")
    //-     source(src='~@/../static/video/intro.mp4', type="video/mp4")
    //- div.ribbon
    //-   h3.content RIDDLE FILMS PRESENTS A LARRY WEINSTEIN FILM

    //- div.banner.absolute
    //-   img.fl(src="~@/assets/bandeau_end_left.svg")
    //-   h3.w-50.fl RIDDLE FILMS PRESENTS A LARRY WEINSTEIN FILM
    //-   img.fl(src="~@/assets/bandeau_end_right.svg")
    //- div.mt3
    //-   img.pb3(src="~@/assets/Logo_rouge.png", width="250px")

    div.logointro
      img.logointro2(src="~@/assets/newlogos/logos_intro_DOAJC_montage.png")

    //- div.logocontainer
    //-   img(src="~@/assets/newlogos/riddle_film.png", width="150px")
    //-   img(src="~@/assets/newlogos/logo_DOAJC_cropped.png", width="400px")
    //-   img.pb3(src="~@/assets/newlogos/larry_weinstein.png", width="250px")
    div.soustitreintro.mb1.ph2
      h1 The amazing story of a group of jewish songwriters who wrote the soundtrack to christmas
      //- pre {{date_de_diffusion}}
    div.enterbouton.pb5.pt1
      router-link(:to="{ name: 'hello'}")
        img(src="~@/assets/enter_bouton.svg", width="100px")
    div.bandeauinfos.pt2.pb3.shadow-up-4()
      q-carousel.text-white(infinite='', autoplay='', v-if='date_de_diffusion.length > 0')
        .sliderstyle2(slot='slide', v-for='date in date_de_diffusion[0].page_containers')
          div.w-100.flex-inline
            div(v-html='date.container.description')
            div.images(v-if='date.container.medias.length > 0')
              img.pl2(:src='date.container.medias[0].image.url')
    //- div.bandeauinfos.pt2.pb3.shadow-up-4
      div
        div.w-100.flex-inline
          span Watch the world premiere on
          img.pl2(src="~@/assets/373x100/documentary-cropped.png", width="90px")
      div
        span DECEMBER 3RD, 2017 AT 8PM ET
      div.flex
        div.w-100
          span AND ON
          img.v-mid.mh2(src="~@/assets/373x100/cbc-cropped.png", width="65px")
          span DECEMBER 7TH, 2017 AT 9PM ET
    q-carousel.carousellogos.text-white(infinite='', autoplay='')
      .sliderstyle(slot='slide')
        div.images
          img(src="~@/assets/373x100/cbc-cropped.png", width="85px;")
      .sliderstyle(slot='slide')
        div.images
          img(src="~@/assets/373x100/svt-cropped.png", width="100px;")
      .sliderstyle(slot='slide')
        div.images
          img(src="~@/assets/373x100/documentary-cropped.png", width="120px;")
      .sliderstyle(slot='slide')
        div.images
          img(src="~@/assets/373x100/arte-cropped.png", width="100px;")
      .sliderstyle(slot='slide')
        div.images
          img(src="~@/assets/373x100/rogers-cropped.png", width="150px;")
      .sliderstyle(slot='slide')
        div.images
          img(src="~@/assets/373x100/yle-cropped.png", width="50px;")
      .sliderstyle(slot='slide')
        div.images
          img(src="~@/assets/373x100/NK-cropped.png", width="70px;")
      .sliderstyle(slot='slide')
        div.images
          img(src="~@/assets/373x100/ndr-cropped.png", width="80px;")
      .sliderstyle(slot='slide')
        div.images
          img(src="~@/assets/373x100/RSI-cropped.png", width="60px;")
      .sliderstyle(slot='slide')
        div.images
          img(src="~@/assets/373x100/cmf-cropped.png", width="200px;")
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.home{
  /*overflow-x: hidden;*/
  width:100vw;
  /*height:100%;*/
  min-height:100vh!important;
  /*overflow-y: hidden;*/
  background-image: url('~@/assets/newlogos/BKG-LAYERS-DJC_nologo.jpg');
  background-position:center;
  background-size: cover;
}
.logointro{
  -moz-animation: fadeIn 1.5s 2s;
  -webkit-animation: fadeIn 1.5s 2s;
  animation: fadeIn 1.5s 2s;
  animation-fill-mode: both;
}
.soustitreintro{
  -moz-animation: fadeIn 1.5s 3s;
  -webkit-animation: fadeIn 1.5s 3s;
  animation: fadeIn 1.5s 3s;
  animation-fill-mode: both;
  margin:0 auto 10% auto;
  text-align: center;
  width:90%;
}
.enterbouton{
  -moz-animation: fadeIn 1.5s 4s;
  -webkit-animation: fadeIn 1.5s 4s;
  animation: fadeIn 1.5s 4s;
  animation-fill-mode: both;
}
.bandeauinfos, .carousellogos{
  -moz-animation: fadeInUp 1.5s 5s;
  -webkit-animation: fadeInUp 1.5s 5s;
  animation: fadeInUp 1.5s 5s;
  animation-fill-mode: both;
}
.bandeauinfos{
  background-color:red;
  opacity: 1;
}
.logointro2{
  height:380px;
  margin:0 auto;
}
.sliderstyle{
  background-color:rgba(0,0,0,0.5);
  display:flex;
  justify-content: space-around;
  min-height:100px;
}
.sliderstyle2{
  & p{
    font-family:Marketdeco;
    font-size: 16px;
    color: #fff;
    line-height:16px;
  }
}
@media only screen and (min-width: 320px){
  .layout-footer {
    border-top:0px;
  }
  .imgbackground{
  }
  .home{
    & span{
    font-family:Marketdeco;
    font-size: 16px;
    color: #fff;
    line-height:30px;
    }
    & h1{
    font-family:Marketdeco;
    font-size: 18px;
    color: white;
    }

    & h3{
    font-family:marketdeco;
    font-size: 16px;
    color:#fff;
    /*background-color:red;*/
    /*padding: 10px;*/
    /*margin: 0 20px 0 20px;*/
    margin: 0 auto;
    }
  }
}
@media only screen and (min-width: 320px) and (orientation:landscape) {
  .home{

  }
  .sliderstyle{
    background-color:rgba(0,0,0,1);
    display:flex;
    justify-content: space-around;
    min-height:100px;
  }
}
@media only screen and (min-width: 768px){
  .home{
    height:100%;
    & h1{
    font-family:Marketdeco;
    font-size: 22px;
    line-height:26px;
    color: white;
    }
  }
  .sliderstyle{
    background-color:rgba(0,0,0,1);
    display:flex;
    justify-content: space-around;
    min-height:100px;
  }
  .logointro2{
    height:500px!important;
    margin:0 auto;
  }
}

@media only screen and (min-width: 961px){
  .home{
  min-height:100vh;
  }
  .soustitreintro{
    margin:0 auto 10% auto;
    text-align: center;
    max-width:500px;
    line-height: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?25b5b280